import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ExcelService } from 'src/app/services/excel.service';
import axios from 'axios';

@Component({
  selector: 'app-file-excel',
  templateUrl: './file-excel.component.html',
  styleUrls: ['./file-excel.component.css']
})
export class FileExcelComponent implements OnInit {

  constructor(
    private excelService: ExcelService,
    private spinner: NgxSpinnerService,
  ) { }

  ngOnInit(): void {
    this.Loaddata();
  }

  text_f: String;
  dataApi = []
  Loaddata() {
    this.spinner.show()
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[CPS6263].[dbo].[link_api]&w=status=1 order by type_link";
    axios.get(url).then(res => {
      this.spinner.hide();
      let data = res.data;
      if (data.length > 0) {
        //this.dataApi.sort((a, b) => { return (a.type_link) - (b.type_link)});
        data = data.map(item => {
          return { ...item, Loadding: false };
        });
        this.dataApi = (data);
        //console.log('dataApi',this.dataApi);
      }
    }).catch(err => { throw (err) })
  }

  Load = false;
  Loaddata0(ep: any) {
    this.Load = true;
    console.log('data_ep:', ep);
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/" + ep.Entry_point + "?s=*&f=" + ep.link_api + ep.and_link;
    //console.log('url- ', url);
    axios.get(url).then(res => {
      this.Load = false;
      let data = (res.data);
      if (data.length > 0) {
        this.exportAsXLSX(data, ep.name)
        //console.log('data',data);
      }
      else {
        this.spinner.hide();
        alert("ไม่สามารถโหลด " + ep.name + " ได้");
      }
      this.dataApi.forEach(item => {
        item.Loadding = false;
      });
    }).catch(err => { throw (err) })
  }

  exportAsXLSX(data, name): void {
    this.excelService.exportAsExcelFile(data, name);
  }

}
